document.addEventListener('DOMContentLoaded', () => {
  const key = new URLSearchParams(location.search).get('vendor');
  if (!key) return;

  const node = document.querySelector(
    `script.hub-vendor[data-vendor-key="${CSS.escape(key)}"]`,
  );
  if (!node) return;

  let vendor;
  try {
    vendor = JSON.parse(node.textContent);
  } catch {
    return;
  }

  document.querySelectorAll('[data-hub="headline"]').forEach((el) => {
    el.textContent = vendor.headline;
  });

  document.querySelector('[data-hub="copy"]').innerHTML = vendor.copy;

  const image = document.querySelector('[data-hub="image"]');
  image.removeAttribute('srcset');
  image.src = vendor.image;
  image.alt = vendor.imageAlt;

  if (vendor.logo) {
    document.querySelectorAll('[data-hub="logo"]').forEach((slot) => {
      slot.append(
        Object.assign(document.createElement('img'), {
          className: 'hub-intro-logo mar-b-50 m-mar-b-30',
          src: vendor.logo,
          alt: vendor.logoAlt,
        }),
      );
    });
  }
});
